export default "__VITE_ASSET__970f84d0__"